import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used within ThemeProvider');
  return context;
};

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    // Force light mode - remove any dark class and clear stored preference
    document.documentElement.classList.remove('dark');
    localStorage.removeItem('theme');
  }, []);

  // Return static light theme - toggleTheme is a no-op for backward compatibility
  return (
    <ThemeContext.Provider value={{ theme: 'light', toggleTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
};
